import { useEffect } from "react";

import { useToolbarLayer } from "./ToolbarLayerContext";

/**
 * Registers a flyout's open state with the nearest ToolbarLayerProvider so it
 * can suppress column-level tooltip visibility while the flyout is open.
 */
export function useFlyoutRegistration(open: boolean) {
    const { onFlyoutOpenChange } = useToolbarLayer();

    useEffect(() => {
        if (!open) {
            return;
        }
        onFlyoutOpenChange(true);
        return () => onFlyoutOpenChange(false);
    }, [open, onFlyoutOpenChange]);
}
